'use strict';

import { firebase, getSecuredFirestore, getStorage } from "./Firestore.js";
import moment from "moment";

async function uploadImageToStorage(id, base64Image) {
  return getStorage().then(function (storage) {
    if (base64Image) {
      var storageRef = storage.ref();
      var imageRef = storageRef.child(
        id + "." + base64Image.match(/[^:/]\w+(?=;|,)/)[0]
      );
      return imageRef
        .putString(base64Image.split("base64,")[1], "base64")
        .then(function (snapshot) {
          return snapshot.ref.getDownloadURL();
        });
    } else {
      return null;
    }
  });
}

async function createOrder(
  test,
  name,
  address,
  location,
  items,
  paymentMethod,
  deliveryDate,
  deliveryTime,
  deliveryPrice,
  userRef,
  paymentSlip,
  cartDoc
) {
  return getSecuredFirestore().then(function (firestore) {
    let orderId = firestore.collection("orders").doc().id;

    let totalAmount = items
      .map(i => i.product.price * i.amount)
      .reduce((a, b) => a + b, 0) + deliveryPrice;

    return uploadImageToStorage(orderId, paymentSlip).then(function (imageUrl) {
      let orderData = {
        test: test === undefined ? false : test,
        status: "Pending",
        name: name,
        address: address,
        items: items,
        totalAmount: totalAmount,
        paymentMethod: paymentMethod,
        paymentStatus: paymentMethod === "cash" ? "Outstanding" : "Paid",
        delivery: {
          date: deliveryDate
            ? firebase.firestore.Timestamp.fromDate(deliveryDate)
            : null,
          time: deliveryTime,
          price: deliveryPrice,
          location: location
        },
        userRef: userRef,
        created: firebase.firestore.FieldValue.serverTimestamp(),
        paymentSlipUrl: imageUrl
      };

      return firestore
        .collection("orders")
        .doc(orderId)
        .set(orderData)
        .then(function () {
          // cleanup cart
          cartDoc
            .update({
              items: [],
              deliveryPrice: 0,
              deliveryDate: firebase.firestore.FieldValue.delete(),
              deliveryTime: firebase.firestore.FieldValue.delete(),
              overwrittenUserRef: firebase.firestore.FieldValue.delete()
            })
            .catch(function (e) {
              console.log(e);
            });

          return { orderId: orderId, orderData: orderData };
        });
    });
  });
}

function createOrderNotificationMessage(orderId, orderData, locale) {
  let message = orderId + "\n\n" + (orderData.test ? "-----------------------------------------------THIS IS A TEST ORDER-----------------------------------------------\n\n" : "") + orderData.name + "\n";
  message += orderData.address + "\n\n";

  message +=
    "ยอดชำระเงินทั้งหมด: " +
    orderData.totalAmount.toLocaleString(locale, {
      minimumFractionDigits: 2
    }) +
    " THB\n";

  for (let index = 0; index < orderData.items.length; index++) {
    const item = orderData.items[index];
    message +=
      "  - " + item.amount + "x " + item.product.title + "\n";
  }
  message += "\n";

  message += "โหมดการชำระเงิน: " + orderData.paymentMethod.toUpperCase() + "\n\n";

  message += "การจัดส่งสินค้า" + "\n";
  if (orderData.delivery.date) {
    message +=
      "  - วันที่: " +
      moment(orderData.delivery.date.toDate()).format("Do MMMM YYYY") +
      "\n";
  }
  if (orderData.delivery.time) {
    message += "  - เวลา: " + orderData.delivery.time + "\n";
  }
  if (orderData.delivery.price > 0) {
    message +=
      "  - ราคา: " + orderData.delivery.price.toLocaleString(locale, {
        minimumFractionDigits: 2
      }) + " THB\n";
  }
  if (orderData.delivery.location) {
    message +=
      "  - ตำแหน่งบน Google Maps: " +
      "https://www.google.com/maps/search/" +
      orderData.delivery.location.latitude +
      "," +
      orderData.delivery.location.longitude;
  }

  message += "\n\nรายละเอียดคำสั่งซื้อ: " + process.env.LIFF_SERVER_URL + "/Order/" + orderId;
  return message;
}

export { createOrder, createOrderNotificationMessage };